export const DistributorApiHealthStatuses = {
  Healthy: "healthy",
  ServiceOutage: "service_outage",
  ScheduledMaintenance: "scheduled_maintenance",
  Unknown: "unknown",
} as const;

export type DistributorApiHealthStatus =
  (typeof DistributorApiHealthStatuses)[keyof typeof DistributorApiHealthStatuses];

export const DistributorApiHealthLabels: Record<
  DistributorApiHealthStatus,
  string
> = {
  [DistributorApiHealthStatuses.Healthy]: "Healthy",
  [DistributorApiHealthStatuses.ServiceOutage]: "Service Outage",
  [DistributorApiHealthStatuses.ScheduledMaintenance]: "Scheduled Maintenance",
  [DistributorApiHealthStatuses.Unknown]: "Unknown",
};

export const DistributorApiHealthOptions = Object.values(
  DistributorApiHealthStatuses,
);
